export enum ScreenId {
  HOME = "/",
  LOGIN = "/login",
  ABOUT = "/about",
  ORGANIC = "/organic",
  NOTICE = "/notice",
  NOTICE_DETAIL = "/notice/detail",
  BOARD = "/board",
  BOARD_DETAIL = "/board/detail",
  MEMBER = "/member",
  KAKAO_LOGIN_CALLBACK = "/auth/kakao/callback",
}

export enum AdminScreenId {
  HOME = "/admin/home",
  ADV = "/admin/adv",
  ABOUT = "/admin/about",
  ORGANIC = "/admin/organic",
  NOTICE = "/admin/notice",
  NOTICE_DETAIL = "/admin/notice/detail",
  BOARD = "/admin/board",
  BOARD_DETAIL = "/admin/board/detail",
  MEMBER = "/admin/member",
  MEMBER_DETAIL = "/admin/member/detail",
  USER = "/admin/user",
  POPUP = "/admin/popup",
  POPUP_DETAIL = "/admin/popup/detail",
}
